import { reactive } from 'vue'

export const LayoutStore = reactive({
    _mobile: window.innerWidth < 768,

    isMobile: function () {
        return this._mobile;
    },

    _updateMobile() {
        this._mobile = window.innerWidth < 768;
    }
});

// Listen for resize and orientation changes
window.addEventListener('resize', () => LayoutStore._updateMobile());
window.addEventListener('orientationchange', () => {
    setTimeout(() => LayoutStore._updateMobile(), 100);
});